import { PinterestIcon } from '@/shared/components/primitives/svg/pinterest-icon';
import { FacebookIcon } from '@/shared/components/primitives/svg/facebook-icon';
import { XIcon } from '@/shared/components/primitives/svg/x-icon';
import { YouTubeIcon } from '@/shared/components/primitives/svg/youtube-icon';
import { cn } from '@/shared/utils/cn';

export const SocialLoginLinks = ({ className }: { className?: string }) => {
  const socialLinks = [
    {
      labelKey: 'Facebook',
      icon: <FacebookIcon />,
      href: 'https://www.facebook.com/WildTangentGames',
    },
    { labelKey: 'Youtube', icon: <YouTubeIcon />, href: 'https://www.youtube.com/c/wildtangent' },
    { labelKey: 'X', icon: <XIcon />, href: 'https://x.com/PlayWildTangent' },
    {
      labelKey: 'Pinterest',
      icon: <PinterestIcon />,
      href: 'https://www.pinterest.com/playwildtangent/',
    },
  ] as const;

  return (
    <ul className={cn('flex h-11 w-full max-w-60 items-center justify-between', className)}>
      {socialLinks.map((link) => (
        <li key={link.labelKey}>
          <a
            href={link.href}
            target='_blank'
            rel='noopener noreferrer'
            aria-label={link.labelKey}
            title={link.labelKey}
            className='hover:text-primary transition-colors'
          >
            {link.icon}
          </a>
        </li>
      ))}
    </ul>
  );
};
